import React, { Fragment, ReactElement, useContext, useState } from 'react';
import { MappingClientT, StatusClientT } from 'bovaljaren-models';
import './SvgMapping.scss';
import { isMobile } from '../../../../utils/app.helper';
import { useObserver } from 'mobx-react-lite';
import SvgMappingViewPolygons from './SvgMappingViewPolygons/SvgMappingViewPolygons';
import SvgMappingPoiPolygons from './SvgMappingPoiPolygons/SvgMappingPoiPolygons';
import SvgMappingObjectPolygons from './SvgMappingObjectPolygons/SvgMappingObjectPolygons';
import SvgMappingCanvas from './SvgMappingCanvas.tsx/SvgMappingCanvas';
import { AppContext } from '../../../../state/app.state';


type Props = {
    onObjectClick: (objectId: number | null) => void;
    onObjectMouseEnter?: (object: MappingClientT) => void;
    onObjectMouseLeave?: (object: MappingClientT) => void;
    onCanvasClick?: () => void;
    disableObjectTouchInteraction?: boolean;
}

export const getObjectClassNameFromStatus = (statuses?: StatusClientT[], objectStatusId?: number): string => {
    const result = statuses?.find(s => s.id === objectStatusId)?.type;

    return `bv-${result}` || '';
};

const SvgMapping: React.FC<Props> = ({ onObjectClick, onObjectMouseEnter, onObjectMouseLeave, onCanvasClick, disableObjectTouchInteraction = false }): ReactElement => {
    const [lastHovered, setLastHovered] = useState('');
    const [hoverStart, setHoverStart] = useState<Date>();

    const checkHoverTimer = () => {
        return !isMobile() && (hoverStart ? (Math.abs(new Date().getTime() - hoverStart.getTime())) > 1500 : true);
    };


    return useObserver(() => (<Fragment>
        <SvgMappingCanvas
            onCanvasClick={onCanvasClick}
            disableObjectTouchInteraction={disableObjectTouchInteraction}
        />
        <SvgMappingViewPolygons
            onObjectMouseEnter={onObjectMouseEnter}
            onObjectMouseLeave={onObjectMouseLeave}
            disableObjectTouchInteraction={disableObjectTouchInteraction}
            lastHovered={lastHovered}
            setLastHovered={setLastHovered}
        />
        <SvgMappingPoiPolygons
            onObjectMouseEnter={onObjectMouseEnter}
            onObjectMouseLeave={onObjectMouseLeave}
            disableObjectTouchInteraction={disableObjectTouchInteraction}
            lastHovered={lastHovered}
            setLastHovered={setLastHovered}
            checkHoverTimer={checkHoverTimer}
        />
        <SvgMappingObjectPolygons
            onObjectMouseEnter={onObjectMouseEnter}
            onObjectMouseLeave={onObjectMouseLeave}
            disableObjectTouchInteraction={disableObjectTouchInteraction}
            lastHovered={lastHovered}
            setLastHovered={setLastHovered}
            checkHoverTimer={checkHoverTimer}
            setHoverStart={setHoverStart}
            onObjectClick={onObjectClick}
        />
    </Fragment>
    ));
};

export default SvgMapping;